import React from 'react';

import { Dialog, DialogContent } from '../../components/material-ui/Dialog';
import { WhatsNewModalContent } from './WhatsNewModalContent';
import { useStyles } from './useStyles';

export const WhatsNewModal = React.forwardRef((props, ref) => {
    const classes = useStyles();

    return (
        <Dialog fullScreen={true} open={true}>
            <DialogContent ref={ref} className={classes.container}>
                <WhatsNewModalContent {...props} />
            </DialogContent>
        </Dialog>
    );
});
